import React from "react"
import { useSelector } from "react-redux"

import { VIEW } from "const"
import { hasAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    StoreType,
} from "client/store"
import {
    Container,
    PageContent,
} from "client/components"

import DefaultUserSettings from "./defaultUserSettings"
import DefaultGroups from "./defaultGroups"

const Project = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const viewAccess = hasAccess(PRM_ACCOUNT_SETTINGS, VIEW)

    return (
        <Container>
            <PageContent>
                { userData.accountId !== 1 && <DefaultUserSettings /> }
                { viewAccess && <DefaultGroups /> }
            </PageContent>
        </Container>
    )
}
export default Project
